// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5g-0";
export var eligibilityCardNotEligible = "_5g-1";